<form [formGroup]="searchClaimByMemberDetailsForm" autocomplete="off">
  <div class="flex flex-col gap-4">
    <!-- member id -->
    <div>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="memberId"
        placeholder="Member ID"
        data-test-id="claim-member-id-input"
      />
      @if (memberIdClaimInput.invalid && (memberIdClaimInput.dirty || memberIdClaimInput.touched)) {
        <errors-messages-inline>
          Please enter a valid member number
        </errors-messages-inline>
      }
      @if (memberIdClaimInput.hasError('memberId') && (memberIdClaimInput.dirty || memberIdClaimInput.touched)) {
        <errors-messages-inline>
          Member Number is <strong>required</strong>
        </errors-messages-inline>
      }
    </div>
    <!-- last name -->
    <div>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="lastName"
        placeholder="Last Name"
        data-test-id="claim-last-name-input"
      />
      @if (memberLastNameClaimInput.invalid && (memberLastNameClaimInput.dirty || memberLastNameClaimInput.touched)) {
        <errors-messages-inline>
          Please enter a valid last name
        </errors-messages-inline>
      }
      @if (memberLastNameClaimInput.hasError('lastName') && (memberLastNameClaimInput.dirty || memberLastNameClaimInput.touched)) {
        <errors-messages-inline>
          Last name is <strong>required</strong>
        </errors-messages-inline>
      }
    </div>
    <!-- Date of birth -->
    <div>
      <p-date-picker
        inputId="date-of-birth"
        formControlName="dateOfBirth"
        dateFormat="mm/dd/yy"
        selectionMode="single"
        [monthNavigator]="true"
        [yearNavigator]="true"
        [showButtonBar]="true"
        [yearRange]="yearOfBirthRange"
        [maxDate]="birthDateMaxSelectableDate"
        [showIcon]="true"
        appendTo="body"
        placeholder="Date of Birth"
        data-test-id="claim-date-of-birth-calendar"
      ></p-date-picker>
      @if (memberDOBClaimInput.invalid && (memberDOBClaimInput.dirty || memberDOBClaimInput.touched)) {
        <errors-messages-inline>
          Please enter a valid Date of Birth
        </errors-messages-inline>
      }
      @if (memberDOBClaimInput.hasError('lastName') && (memberDOBClaimInput.dirty || memberDOBClaimInput.touched)) {
        <errors-messages-inline>
          Date of Birth is <strong>required</strong>
        </errors-messages-inline>
      }
    </div>
  </div>
</form>

<div class="text-center my-2">or</div>

<div class="flex flex-col gap-4">
  <form [formGroup]="searchClaimByServiceDateDetailsForm" autocomplete="off">
    <p-date-picker
      inputId="date-of-birth"
      formControlName="dateRangeOfService"
      dateFormat="mm/dd/yy"
      selectionMode="range"
      [monthNavigator]="true"
      [yearNavigator]="true"
      [showButtonBar]="true"
      [yearRange]="yearOfBirthRange"
      [maxDate]="birthDateMaxSelectableDate"
      [showIcon]="true"
      appendTo="body"
      placeholder="Date Range of Service"
      data-test-id="claim-date-of-service-calendar"
    ></p-date-picker>
  </form>

  <form [formGroup]="searchClaimByClaimIdDetailsForm" autocomplete="off">
    <input
      pInputText
      type="text"
      class="w-full"
      formControlName="mynexusclaimid"
      placeholder="Carelon Claim ID"
      data-test-id="claim-carelon-id-input"
    />
  </form>

  <form [formGroup]="searchClaimByPatientControlNumberDetailsForm" autocomplete="off">
    <input
      pInputText
      type="text"
      class="w-full"
      formControlName="patientcontrolnumber"
      placeholder="Patient Control Number"
      data-test-id="claim-control-number-input"
    />
  </form>
</div>

<div class="flex justify-end gap-2 mt-4">
  <button
    pButton
    type="button"
    class="p-button-secondary"
    label="Reset"
    data-test-id="claim-reset-button"
    [disabled]="disableBtn()"
    (click)="onResetClaimForm()"
  ></button>
  <button
    pButton
    type="button"
    class="p-button-warning"
    label="Search"
    data-test-id="claim-search-button"
    [disabled]="disableBtn()"
    (click)="onSearchClaim()"
  ></button>
</div>
